<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SelectContainerInfo')"
    width="800px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button type="primary" @click="saveHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'TradeDetailContainerLinkedDialog',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: false },
    selPoItems: { type: Array, required: false }, // 货物明细(SETradeDetail)页面选择的数据
    relatedContainerUsage: { type: Array, required: false } // 已经关联过的containerUsage的key
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqSize')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqType')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerNo')
          }
        },
        // {
        //   headerName: this.$t('SeaExport.ContainerWeight'),
        //   field: 'containerWeight',
        //   width: 80,
        //   cellRenderer: (params) => {
        //     return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerWeight')
        //   }
        // },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'sealNo')
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      selectedData: {}
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.queryHandler()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.queryHandler()
    }
  },
  methods: {
    queryHandler() {
      const usageDatas = []
      if (this.job.containerUsages) {
        for (const usage of this.job.containerUsages) {
          if (!this.relatedContainerUsage.includes(usage.uuid) && !usageDatas.includes(usage)) {
            usageDatas.push(usage)
          }
        }
        this.rowData = usageDatas
      }
    },
    saveHandler() {
      const selUsages = this.gridApi.getSelectedRows()
      // 验证勾选（只能勾选一条数据）
      if (selUsages == null || selUsages.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'),)
        return
      } else if (selUsages.length > 1) {
        this.$message.warning(this.$t('Message.OnlySelectOneData'))
        return
      } else {
        const selUsage = selUsages[0]
        // 验证件毛体
        const msg = this.validate(selUsage)
        if (msg) {
          this.$message.warning({ dangerouslyUseHTMLString: true, message: msg })
          return
        }
        this.$emit('linkUsagesEventHandler', selUsage)
        this.innerVisible = false
      }
    },
    validate(usage) {
      let quantity = 0
      let weight = 0
      let cubage = 0
      for (const selPoItem of this.selPoItems) {
        quantity += selPoItem.quantity
        weight += isNaN(selPoItem.grossWeight) ? 0 : selPoItem.grossWeight
        cubage += isNaN(selPoItem.cubage) ? 0 : selPoItem.cubage
      }
      quantity = Number(quantity.toFixed())
      weight = Number(weight.toFixed(2))
      cubage = Number(cubage.toFixed(3))
      return this.getCompareMessage(usage, quantity, weight, cubage)
    },

    getCompareMessage(usage, quantity, weight, cubage) {
      let strQuantity = 0
      let strWeight = 0
      let strCubage = 0
      let msg = ''

      if (usage) {
        strQuantity = usage.quantity
        strWeight = isNaN(usage.weight) ? 0 : usage.weight
        strCubage = isNaN(usage.cubage) ? 0 : usage.cubage
      }

      if (quantity === strQuantity && weight === strWeight && cubage === strCubage) { return null }

      if (!StrUtils.NumberIsSame(quantity, strQuantity)) {
        if (quantity > strQuantity) {
          msg += this.$t('Message.DetailedNumberOfCheckedGoods') + quantity + this.$t('CargoMsg.Cargo_GreaterThan') + this.$t('Message.NumberAssociatedPackingInformationPieces') + strQuantity + ' <br/>'
        } else {
          msg += this.$t('Message.DetailedNumberOfCheckedGoods') + quantity + this.$t('CargoMsg.Cargo_LessThan') + this.$t('Message.NumberAssociatedPackingInformationPieces') + strQuantity + ' <br/>'
        }
      }
      if (!StrUtils.NumberIsSame(weight, strWeight, 2)) {
        if (weight > strWeight) {
          msg += this.$t('Message.DetailedWeightOfGoodsChecked') + weight + this.$t('CargoMsg.Cargo_GreaterThan') + this.$t('Message.AssociatedPackingInformationWeight') + strWeight + ' <br/>'
        } else {
          msg += this.$t('Message.DetailedWeightOfGoodsChecked') + weight + this.$t('CargoMsg.Cargo_LessThan') + this.$t('Message.AssociatedPackingInformationWeight') + strWeight + ' <br/>'
        }
      }
      if (!StrUtils.NumberIsSame(cubage, strCubage, 3)) {
        if (cubage > strCubage) {
          msg += this.$t('Message.DetailedVolumeOfGoodsChecked') + cubage + this.$t('CargoMsg.Cargo_GreaterThan') + this.$t('Message.AssociatedPackingInformationVolume') + strCubage + ' <br/>'
        } else {
          msg += this.$t('Message.DetailedVolumeOfGoodsChecked') + cubage + this.$t('CargoMsg.Cargo_LessThan') + this.$t('Message.AssociatedPackingInformationVolume') + strCubage + ' <br/>'
        }
      }
      if (msg === '') {
        return null
      }
      return msg
    }
  }

}
</script>

<style>
</style>
